import React from "react";

const IconUploadIcon = () => {
  return (
    <>
      <svg width="18.405" height="16.811" viewBox="0 0 18.405 16.811">
        <g id="Group_351" data-name="Group 351" transform="translate(-2.25 -3)">
          <path
            id="Path_2541"
            data-name="Path 2541"
            d="M19.956,12.336V8.15a4.65,4.65,0,0,0-4.65-4.65H7.4A4.65,4.65,0,0,0,2.75,8.15v6.51a4.65,4.65,0,0,0,4.65,4.65h5.822"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_2542"
            data-name="Path 2542"
            d="M3.01,15.811l2.546-2.825a2.125,2.125,0,0,1,2.573-.238,2.125,2.125,0,0,0,2.573-.238l2.165-2.057a3.862,3.862,0,0,1,4.794-.38l2.295,1.686M7.655,9.781A1.467,1.467,0,1,0,7.637,6.85a1.467,1.467,0,1,0,.019,2.931"
            transform="translate(0 0)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_2543"
            data-name="Path 2543"
            d="M18.707,15v5"
            transform="translate(-1.294 -1.189)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            stroke-miterlimit="10"
            strokeWidth="1"
          />
          <path
            id="Path_2544"
            data-name="Path 2544"
            d="M21,17.1l-1.967-1.967a.46.46,0,0,0-.652,0L16.414,17.1"
            transform="translate(-1.294 -0.918)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </g>
      </svg>
    </>
  );
};

export default IconUploadIcon;
